type Args = {
    type: string,
    id: number,
    goal: string
}

declare global {
    interface Window {
        _tmr: {
            push: (args: Args) => void
        };
    }
}

export const callVKPixel = (goal: string) =>
    window._tmr.push({ type: 'reachGoal', id: 3718645, goal });
